import React, { useMemo } from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import { logger } from '../logger';

const RightRail = ({ messages = [] }) => {
  const recentQuestions = useMemo(() => {
    const sanitize = (s) =>
      (s || '')
        .replace(/^[\s*_`"'~-]+/, '') // cleaned (removed \ before -)
        .replace(/[\s*_`"'~-]+$/, '') // cleaned (removed \ before -)
        .trim();

    // Get user messages, keep order, take last 30 then unique & reverse (latest first)
    const userMsgs = messages.filter(m => m.type === 'user');
    const last = userMsgs.slice(-30); // window
    const seen = new Set();
    const dedup = [];
    for (let i = last.length - 1; i >= 0; i--) {
      let txt = sanitize(last[i].content);
      if (!txt) continue;
      const key = txt.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      dedup.push({ id: last[i].id, text: txt, ts: last[i].timestamp });
      if (dedup.length === 10) break; // limit
    }
    const result = dedup;
    logger.debug('[RightRail] recentQuestions count:', result.length);
    return result; // already newest → oldest
  }, [messages]);

  return (
    <Box
      component="aside"
      className="right-rail"
      sx={{
        width: { md: 'clamp(200px, 18vw, 280px)' },
        bgcolor: '#fff',
        borderLeft: 'none',
        p: { xs: 2, md: 2.5 },
        display: { xs: 'none', md: 'flex' },
        position: 'relative',      // changed from sticky (no page scroll now)
        height: '100%',
        boxSizing: 'border-box',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ flexShrink: 0, mb: 1 }}>
        <Typography variant="overline" sx={{ color: '#666', fontWeight: 700, letterSpacing: '0.04em' }}>
          RECENT QUESTIONS
        </Typography>
      </Box>
      <Box
        sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            pr: 0.5,
            '&::-webkit-scrollbar': { width: 0, height: 0 },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        }}
      >
        <List dense disablePadding>
          {recentQuestions.map(q => (
            <ListItem
              key={q.id}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                px: 0,
                py: 0.75,
                borderBottom: '1px solid #f2f2f2',
                fontSize: 13,
                color: '#333'
              }}
            >
              <span style={{ lineHeight: 1.25 }}>{q.text}</span>
            </ListItem>
          ))}
          {recentQuestions.length === 0 && (
            <Typography variant="caption" sx={{ color: '#888' }}>
              No questions yet.
            </Typography>
          )}
        </List>
      </Box>
    </Box>
  );
};

export default RightRail;
